import { render, staticRenderFns } from "./newFolder.vue?vue&type=template&id=fae5e3b0&scoped=true&"
import script from "./newFolder.vue?vue&type=script&lang=js&"
export * from "./newFolder.vue?vue&type=script&lang=js&"
import style0 from "./newFolder.vue?vue&type=style&index=0&id=fae5e3b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae5e3b0",
  null
  
)

export default component.exports